import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.page.html',
  styleUrls: ['./promotion.page.scss'],
})
export class PromotionPage implements OnInit {

  @Input() idPopUp: number = 0;
  public titleText: string = "";
  public infoText: string = "";
  public buttonText: string = "";

  constructor(
    private modalCtrl: ModalController
    , private translate: TranslateService
  ) {
  }

  ngOnInit() {
    switch (this.idPopUp) {
      case 1:
        this.titleText = this.translate.instant('Labels.title-promotion-modal');
        this.infoText = this.translate.instant('Labels.info-promotion-modal');
        this.buttonText = this.translate.instant('Buttons.go-to-promotion');
        break;
      case 2:
        this.titleText = this.translate.instant('Labels.title-sugar-tax-modal');
        this.infoText = this.translate.instant('Labels.info-sugar-tax-modal');
        this.buttonText = this.translate.instant('Buttons.go-to-order');
        break;
      default:
        this.titleText = this.translate.instant('Labels.title-promotion-modal');
        this.infoText = this.translate.instant('Labels.info-promotion-modal');
        this.buttonText = this.translate.instant('Buttons.go-to-promotion');
        break;
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  public onClose = (actionType: 1 | 2) => {
    this.modalCtrl.dismiss(actionType);
  }

}
